import * as React from 'react'

import { Box, Chevron, Icon, Text, useToggle } from '@factorialco/deprecated-design-system'

import Tooltip from '../Tooltip'

type Prop = {
  open: boolean
  label: string
  description?: string
  onOpen: () => void
  onClose: () => void
}

const Subcategory = ({ open, label, description, onOpen, onClose }: Prop) => {
  const [infoTooltip, infotooltipToggle] = useToggle(false)
  const direction = open ? 'up' : 'down'
  const type = open ? 'radical' : 'secondary'
  const color = open ? 'grey1000' : 'grey800'

  return (
    <Box
      background="grey200"
      cursor="pointer"
      flexDirection="row"
      alignItems="center"
      height="s64"
      paddingX="s16"
      gap="s4"
      onClick={() => {
        if (open) {
          onClose()
        } else {
          onOpen()
        }
      }}
    >
      <Box>
        <Chevron type={type} direction={direction} />
      </Box>
      <Text size="300" weight="semibold" color={color}>
        {label}
      </Text>
      {description && (
        <Box onMouseEnter={infotooltipToggle(true)} onMouseLeave={infotooltipToggle(false)}>
          <Icon.Medium icon="info-circle-line" />
          {infoTooltip && <Tooltip label={description} />}
        </Box>
      )}
    </Box>
  )
}

export default Subcategory
